<template>
  <div class="shadow-md border border-gray-200 w-full p-10 mb-3" v-if="subscription">
    <div class="flex justify-between">
      <div class="flex-1">
          <span class="text-lg text-black  font-medium me-2 px-5 py-1 rounded-full bg-[#E2E2E2]"
                v-if="!subscription.isActive">
            Inactive
          </span>
        <span class="text-lg text-black  font-medium me-2 px-5 py-1 rounded-full bg-[#D2FACF]"
              v-if="subscription.isActive">
            Active
          </span>
      </div>

      <div>
        Subscription #{{ subscription.id }}
      </div>
    </div>
    <div class="flex justify-between items-center my-3">
      <div class="flex-1">
        <div class="text-2xl font-bold">{{ subscription.cycle.name }}</div>
        <div class="text-xs font-light text-gray-700 py-1">{{ subscription.publications }} Publications</div>
        <div class="mt-2 flex items-center">
          <IconRenew/>
          <a href="#" class="text-xl text-violet-600" style="margin-left:10px;" v-if="true || subscription.isRenew" @click="openRenewModal">Renew Now</a>
        </div>
      </div>
      <div>
        <span class="text-2xl font-bold">${{ subscription.cycle_price }}</span>
      </div>
    </div>
    <div class="border-solid border-gray-200 border-t text-center pt-5 font-bold text-xl">
      <router-link :to="`/account/subscriptions/${subscription.id}`">
        <span>Manage</span>
      </router-link>
    </div>
    <div class="border-solid border-gray-200 border-y " v-if="isSingle">
      <div class="flex justify-between items-start my-3">
        <div class="flex-1">
          <div class="text-xl font-bold">Delivery information</div>
          <div>{{ subscription.delivery.name }}</div>
          <div>{{ subscription.delivery.address_line_1 }}</div>
          <div v-if="subscription.delivery.address_line_2">{{ subscription.delivery.address_line_2 }}</div>
          <div>{{ subscription.delivery.city }}</div>
          <div>{{ subscription.delivery.state }}</div>
          <div>{{ subscription.delivery.postal_code }}</div>
        </div>
        <div>
          <button @click="openDeliveryEditModal" class="text-black">Edit delivery info</button>
        </div>
      </div>
    </div>

    <div class="border-solid border-gray-200 border-b " v-if="true || isSingle">
      <div class="flex justify-between items-start my-3">
        <div class="flex-1">
          <div class="text-xl font-bold">Payment method</div>
          <div v-if="subscription.credit_card">
            <div class="flex items-center mt-2">
              <svg class="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
              </svg>
              <span class="text-gray-700">**** **** **** {{ subscription.credit_card.last_four }}</span>
              <span class="ml-2 text-sm text-gray-500 capitalize">{{ subscription.credit_card.type }}</span>
            </div>
          </div>
          <div v-else class="text-gray-500 mt-2">
            No payment method on file
          </div>
        </div>
        <div>
          <button @click="openPaymentMethodUpdateModal" class="text-vivid-purple hover:text-purple-700">
            {{ subscription.credit_card ? 'Update payment method' : 'Add payment method' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-start w-full py-4 text-xl font-bold" v-if="isSingle">Subscription timeline</div>
  <div class="shadow-md border border-gray-200 w-full p-10 mb-3" v-if="subscription && isSingle" v-for="order in subscription.orders">
    <div class="flex justify-between">
      <div class="flex-1">
        <div class="text-base font-bold">{{order.date}}</div>
        <div class="text-xs">Subscribed</div>
      </div>
      <div class="text-right">
        <div class="text-base font-bold">Paid ${{order.total}}</div>
        <div class="text-xs" v-if="subscription.credit_card">with card ending in {{subscription.credit_card.last_four}}</div>
      </div>
    </div>
  </div>

  <SharedModal v-model="openRenew" v-if="subscription">
    <RenewSubscriptionModal @close="closeRenewModal" :subscription="subscription"/>
  </SharedModal>
  <SharedModal v-model="openDeliveryEdit" v-if="subscription">
    <DeliveryUpdateModal @close="closeDeliveryEditModal" :delivery="subscription.delivery" :id="subscription.id"/>
  </SharedModal>
  <SharedModal v-model="openPaymentMethodUpdate" v-if="subscription">
    <PaymentMethodUpdateModal
      @close="closePaymentMethodUpdateModal"
      @updated="handlePaymentMethodUpdated"
      :subscription-id="subscription.id"
      :current-payment-method="subscription.credit_card"
    />
  </SharedModal>

</template>
<script lang="ts">
import {defineComponent, ref} from "vue";
import IconRenew from "@components/icons/IconRenew.vue";
import SharedModal from "@components/reusable/SharedModal.vue";
import UserUpdateModal from "@components/account/modal/UserUpdateModal.vue";
import RenewSubscriptionModal from "@components/account/modal/RenewSubscriptionModal.vue";
import DeliveryUpdateModal from "@components/account/modal/DeliveryUpdateModal.vue";
import PaymentMethodUpdateModal from "@components/account/modal/PaymentMethodUpdateModal.vue";

export default defineComponent({
  components: {DeliveryUpdateModal, RenewSubscriptionModal, UserUpdateModal, SharedModal, IconRenew,PaymentMethodUpdateModal},
  props: {
    isSingle: {
      type: Boolean,
      default: false
    },
    subscription: {
      type: Object,
      required: true
    }
  },
  setup() {
    const openRenew = ref(false);
    const openDeliveryEdit = ref(false);
    const openPaymentMethodUpdate = ref(false);

    const openRenewModal = () => {
      openRenew.value = true;
    };
    const closeRenewModal = () => {
      openRenew.value = false;
    };
    const openDeliveryEditModal = () => {
      openDeliveryEdit.value = true;
    };
    const closeDeliveryEditModal = () => {
      openDeliveryEdit.value = false;
    };

    const openPaymentMethodUpdateModal = () => {
      openPaymentMethodUpdate.value = true;
    };
    const closePaymentMethodUpdateModal = () => {
      openPaymentMethodUpdate.value = false;
    };
    const handlePaymentMethodUpdated = () => {
      // The modal will handle refreshing the subscription data
      // through the auth store, so we don't need to do anything here
    };

    return {
      openRenew, openRenewModal, closeRenewModal,
      openDeliveryEdit, openDeliveryEditModal, closeDeliveryEditModal,
      openPaymentMethodUpdate, openPaymentMethodUpdateModal, closePaymentMethodUpdateModal, handlePaymentMethodUpdated
    }
  }
})
</script>